var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import Theme from '../theme.config';
var TestPropsClass = /** @class */ (function (_super) {
    __extends(TestPropsClass, _super);
    function TestPropsClass(props) {
        return _super.call(this, props) || this;
    }
    TestPropsClass.prototype.render = function () {
        return React.createElement("div", { className: this.props.className }, this.props.children);
    };
    return TestPropsClass;
}(React.Component));
var TestStyledProps = styled(TestPropsClass)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  position: fixed;\n  width: 240px;\n  margin-top: 0px;\n  bottom: 0px;\n  left: 0px;\n  top: 0px;\n  ", "\n  ", "\n  ", "\n"], ["\n  background: ", ";\n  position: fixed;\n  width: 240px;\n  margin-top: 0px;\n  bottom: 0px;\n  left: 0px;\n  top: 0px;\n  ",
    "\n  ",
    "\n  ",
    "\n"])), Theme.color.base, function (props) { return props.green &&
    "\n    background: green;\n  "; }, function (props) { return props.dark &&
    "\n    background: black;\n  "; }, function (props) { return props.blue &&
    "\n    background: blue;\n  "; });
Object.assign(TestStyledProps, {
    displayName: 'TestProps',
});
export default TestStyledProps;
var templateObject_1;
//# sourceMappingURL=index.js.map